module.exports = __webpack_public_path__ + "img/banner_article.4665080b.jpg";